import type { FC } from "react";

import { StatusBadge } from "../../shared";
import { complianceStatusTone } from "../../../queries/regulator-portal/compliance/parseComplianceResult";
import type { ComplianceTone } from "../../../queries/regulator-portal/compliance/types";

import styles from "./Compliance.module.css";

type ComplianceStatusBadgeProps = {
  value: string;
  "data-testid"?: string;
};

const STATUS_TONE: Record<ComplianceTone, ComplianceTone> = {
  success: "success",
  danger: "danger",
  warning: "warning",
  info: "info",
  neutral: "neutral",
};

const ComplianceStatusBadge: FC<ComplianceStatusBadgeProps> = ({
  value,
  "data-testid": testId,
}) => (
  <StatusBadge
    tone={STATUS_TONE[complianceStatusTone(value)]}
    size="sm"
    className={styles.status}
    data-testid={testId}
  >
    {value}
  </StatusBadge>
);

export default ComplianceStatusBadge;
